import {PostProductBody} from '../../pages/Bag/Bag';
import AxiosService from '../AxiosService';

/* Substituir depois */
const SalesPost = async (salesData: PostProductBody[], clientCode: string) => {
  const instance = AxiosService.createProductsAxiosInstance();
  const response = await instance.post(
    '/sales',
    {...salesData},
    {
      headers: {
        'client-Code': clientCode,
      },
    },
  );

  return response.data;
};

/* Pagamento no boleto */
const TicketOrderPost = async (
  salesData: PostProductBody[],
  clientCode: string,
  extraHeaders?: Record<string, string>,
) => {
  const instance = AxiosService.createProductsAxiosInstance();
  const response = await instance.post(
    '/sales/order/create',
    {...salesData},
    {
      headers: {
        'client-Code': clientCode,
        ...extraHeaders,
      },
    },
  );

  return response.data;
};

/* Pagamento no Pix */
const PixOrderPost = async (data: any, extraHeaders?: Record<string, string>) => {
  const instance = AxiosService.createProductsAxiosInstance();
  const response = await instance.post('/iopay/pix/order/create', {...data}, {
    headers: extraHeaders,
  });

  return response.data;
};

const PixOrderCheck = async (data: any) => {
  const instance = AxiosService.createProductsAxiosInstance();
  const response = await instance.post('/iopay/pix/order/check', {...data});

  return response.data;
};

/* Pagamento no credito */
const CreditCardOrderPost = async (data: any, extraHeaders?: Record<string, string>) => {
  const instance = AxiosService.createProductsAxiosInstance();
  const response = await instance.post('/iopay/card/credit/order/create', {
    ...data,
  }, {
    headers: extraHeaders,
  });

  return response.data;
};

const DeliveryDateGet = async (clientCode: string) => {
  const instance = AxiosService.createProductsAxiosInstance();
  const response = await instance.get('/client/orderDate', {
    headers: {
      'client-Code': clientCode,
    },
  });

  return response.data;
};

const VerifyDisponibility = async (
  clientCode: string,
  products: PostProductBody[],
) => {
  const instance = AxiosService.createProductsAxiosInstance();

  const response = await instance.post(
    '/sales/verifyDisponibility',
    {...products},
    {
      headers: {
        'client-Code': clientCode,
      },
    },
  );
  return response.data;
};

const PendingPaymentOrders = async (data: any) => {
  try {
    const instance = AxiosService.createProductsAxiosInstance();
    const response = await instance.post('/iopay/pix/recent', {...data});

    return response.data; 
  } catch (error) {
    console.error('Erro ao buscar pagamentos pendentes:', error.response);
    throw error;
  }
};

export default {
  SalesPost,
  TicketOrderPost,
  PixOrderPost,
  PixOrderCheck,
  CreditCardOrderPost,
  DeliveryDateGet,
  VerifyDisponibility,
  PendingPaymentOrders,
};
